import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../img/logo.png'; // Logo por defecto
import whiteLogo from '../img/logo-white.png'; // Logo para la página de Gallery
import '../styles/Header.css';

const Header = () => {
  const [menuOpen] = useState(false);
  const location = useLocation(); // Obtener la ruta actual


  // Cambia el logo si estás en la página de Gallery
  const currentLogo = location.pathname === '/photography' ? whiteLogo : logo;

  return (
    <header className="header">
      <Link to="/">
        <img src={currentLogo} alt="Logo" className="header-logo" />
      </Link>
    </header>
  );
};

export default Header;
